class Accordion {
  constructor(selector) {
    this.$block = $(selector);
    this.$items = this.$block.find('.accordion__item');
    this.$btns = this.$block.find('.accordion__btn');
    this.$contents = this.$block.find('.accordion__content');

    this.init();
  }

  init() {
    this.$btns.on('click', (e) => {
      const $cur = $(e.currentTarget);
      const $curRow = $cur.parent();
      if (!$curRow.hasClass('is-opened')) {
        this.$items.removeClass('is-opened');
        this.$contents.slideUp();
        $curRow
          .addClass('is-opened')
          .children('.accordion__content')
          .slideDown({
            start() {
              $(this).css({
                display: 'flex',
              });
            },
          });
      } else {
        $curRow
          .removeClass('is-opened')
          .children('.accordion__content')
          .slideUp();
      }
    });
  }
}

export default Accordion;
